<template>
  <div>
    <el-upload
      :multiple="false"
      action="#"
      :before-upload="SubmitPicture"
      :show-file-list="true"
      :on-success="handleAvatarSuccess"
      :on-preview="handlePreview"
      :on-remove="handleRemove"
      :before-remove="beforeRemove"
      :file-list="fileList"
      list-type="picture"
    >
      <el-button>Select an image</el-button>
    </el-upload>
   <div v-for="img in this.imgList" :key="img">
      <img :src="img" class="finishedimage" />
      <i
        style="vertical-align: top;position: relative;
               left: -7px;
               bottom: -12px;"
        class="el-icon-error"
        @click="removeImageFromFormSubmit(img)"
      ></i>
    </div>
  </div>
</template>

<script>
import EventService from "@/services/EventService.js";
export default {
  props: {
     propertyid: String
  },
  data() {
    return {
      stringthing: "",
      fileList: [],
      imgList: [],
      imageUrl: "",
      filetopictureidlist: {},
      pictureisuploading: false
    };
  },
  methods: {
    handleAvatarSuccess(res, file) {
      console.log("done!");
      // this.imageUrl = URL.createObjectURL(file.raw);
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file, fileList) {
      console.log(file, fileList);
    },
    SubmitPicture(file) {
      if (!!this.imgList[0] == true) {
        return this.$store.dispatch("addNotification", {
          type: "warning",
          Message: "Only one picture is allowed"
        });
      }
      const MaxContentLength = 1024 * 1024 * 10;
      if (file.size > MaxContentLength) {
        return console.log("image size exceeds 10 megabytes");
      }
      if (file.type != "image/jpeg" && file.type != "image/png") {
        return console.log("This is not a supported file type");
      }
      let picturedetailsobject = {
        imageinformation: [
          {
            contenttype: file.type,
            filename: file.name,
            //should be null for certain picture uploads
            propertyid: null
          }
        ]
      };

   console.log(this.propertyid)

    if(this.propertyid != null && this.propertyid != ""){
      picturedetailsobject.imageinformation[0].propertyid = this.propertyid;
    }
      let presignedurlholder = " presign default";
      this.imgList.push(URL.createObjectURL(file));
      this.pictureisuploading = true;
      EventService.GenerateImageObjectSpaceOnAws(picturedetailsobject)
        .then(response => {
          this.$emit("picture-id", response.data.imageinformationtoreturn[0]);
          this.$emit("displaypicturelocally", URL.createObjectURL(file));
          this.filetopictureidlist.file =
            response.data.imageinformationtoreturn[0].pictureid;
          presignedurlholder =
            response.data.imageinformationtoreturn[0].presignedurl;
        })
        .then(() => {
          EventService.uploadPictureToAws(presignedurlholder, file, file.type);
        })
        .then(() => (this.pictureisuploading = false));
    },
    removeImageFromFormSubmit(img) {
      console.log("this isthe img" + img);
      this.$delete(this.imgList, this.imgList.indexOf(img));
      this.$emit("removePictureId", this.filetopictureidlist.file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `The limit is 3, you selected ${
          files.length
        } files this time, add up to ${files.length + fileList.length} totally`
      );
    },
    beforeRemove(file) {
      return this.$confirm(`Cancel the transfer of ${file.name} ?`);
    },
    logimages(list) {
      this.imgList.push(list);
    }
  }
};
</script>

<style scoped>

.finishedimage {
  height: 90px;
  margin-top: 20px;
  border-radius: 3px;
  object-fit: cover;
}

</style>
